import { useBalanceStore } from '@/entities/balance';

export const useCanUseRecording = (): boolean => {
  const { hasActiveEnterprisePlan, hasActiveSubscription } = useBalanceStore();

  return hasActiveSubscription || hasActiveEnterprisePlan;
};
